import keycloakClient from "@keycloak/keycloak";
import { SOURCE_MANAGER_API_URL } from "../../../config";
import { UploadSourcesRequest } from "./models";

class UploadSourceService {
  private baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  allowedExtensions = ["pdf", "docx", "xlsx", "xls", "csv"];

  private getAuthHeaders(includeContentType: boolean = true): HeadersInit {
    const headers: HeadersInit = {
      Authorization: `Bearer ${keycloakClient.token}`,
      Accept: "application/json"
    };

    if (includeContentType) {
      headers["Content-Type"] = "application/json";
    }

    return headers;
  }

  private handleApiError(error: any): never {
    console.error("Error en la comunicación con el API de fuentes:", error);
    throw error;
  }

  async uploadSources(data: UploadSourcesRequest): Promise<boolean> {
    try {
      const formData = new FormData();

      data.role_ids.forEach((role_id) => {
        formData.append("role_ids", role_id.toString());
      });

      data.files.forEach((file) => {
        formData.append("files", file);
      });

      const response = await fetch(`${this.baseUrl}/sources`, {
        method: "POST",
        headers: this.getAuthHeaders(false),
        body: formData
      });

      if (!response.ok) {
        throw new Error(
          `Error al subir las fuentes: ${response.status} ${response.statusText}`
        );
      }

      return true;
    } catch (error) {
      this.handleApiError(error);
    }
  }
}

export const uploadsSourceService = new UploadSourceService(
  `${SOURCE_MANAGER_API_URL}/chatbot-source-manager-api/v1`
);
